"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
type ReactQueryProviderProps = {
  children: ReactNode;
};
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 60 * 1000, // 1 minute
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});
export default function ReactQueryProvider({
  children
}: ReactQueryProviderProps) {
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="ReactQueryProvider" data-sentry-source-file="react-query.tsx">
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>;
}